import { ACHIEVEMENT_TYPE } from '../data-types/my-achievements/myAchievementsEnums';
import {
  UserAchievement,
  UserBiggestCasinoWinAchievement,
  UserFavouriteCasinoGameAchievement,
  UserFavouriteSportAchievement,
  UserFirstCasinoWinAchievement,
  UserSportsbookAchievement,
} from '../data-types/user/userInterfaces';

export const updateAchievementsStorage = (achievements: UserAchievement[]) => {
  achievements.forEach(achievement => {
    switch (achievement.type) {
      case ACHIEVEMENT_TYPE.FAVOURITE_SPORT:
        if (achievement.value) {
          const latestFavouriteSport = (achievement.value as UserFavouriteSportAchievement).lastBetPlacedAt;
          const currentValue = localStorage.getItem(ACHIEVEMENT_TYPE.FAVOURITE_SPORT);

          if (currentValue !== latestFavouriteSport) {
            localStorage.setItem(ACHIEVEMENT_TYPE.FAVOURITE_SPORT, latestFavouriteSport);
          }
        }
        break;
      case ACHIEVEMENT_TYPE.FAVOURITE_CASINO_GAME:
        if (achievement.value) {
          const latestFavouriteCasinoGame = (achievement.value as UserFavouriteCasinoGameAchievement).createdAt;
          const currentValue = localStorage.getItem(ACHIEVEMENT_TYPE.FAVOURITE_CASINO_GAME);

          if (currentValue !== latestFavouriteCasinoGame) {
            localStorage.setItem(ACHIEVEMENT_TYPE.FAVOURITE_CASINO_GAME, latestFavouriteCasinoGame);
          }
        }
        break;
      case ACHIEVEMENT_TYPE.BIGGEST_CASINO_WIN:
        if (achievement.value) {
          const latestBiggestCasinoWin = (achievement.value as UserBiggestCasinoWinAchievement).createdAt;
          const currentValue = localStorage.getItem(ACHIEVEMENT_TYPE.BIGGEST_CASINO_WIN);

          if (currentValue !== latestBiggestCasinoWin) {
            localStorage.setItem(ACHIEVEMENT_TYPE.BIGGEST_CASINO_WIN, latestBiggestCasinoWin);
          }
        }
        break;
      case ACHIEVEMENT_TYPE.FIRST_CASINO_WIN:
        if (achievement.value) {
          const latestFirstCasinoWin = (achievement.value as UserFirstCasinoWinAchievement).createdAt;
          const currentValue = localStorage.getItem(ACHIEVEMENT_TYPE.FIRST_CASINO_WIN);

          if (currentValue !== latestFirstCasinoWin) {
            localStorage.setItem(ACHIEVEMENT_TYPE.FIRST_CASINO_WIN, latestFirstCasinoWin);
          }
        }
        break;
      case ACHIEVEMENT_TYPE.FIRST_SPORTSBOOK_WIN:
        if (achievement.value) {
          const latestFirstSportsbookWin = (achievement.value as UserSportsbookAchievement).createdAt;
          const currentValue = localStorage.getItem(ACHIEVEMENT_TYPE.FIRST_SPORTSBOOK_WIN);

          if (currentValue !== latestFirstSportsbookWin) {
            localStorage.setItem(ACHIEVEMENT_TYPE.FIRST_SPORTSBOOK_WIN, latestFirstSportsbookWin);
          }
        }
        break;
      case ACHIEVEMENT_TYPE.MOST_RECENT_SPORTSBOOK_WIN:
        if (achievement.value) {
          const latestMostRecentSportsbookWin = (achievement.value as UserSportsbookAchievement).createdAt;
          const currentValue = localStorage.getItem(ACHIEVEMENT_TYPE.MOST_RECENT_SPORTSBOOK_WIN);

          if (currentValue !== latestMostRecentSportsbookWin) {
            localStorage.setItem(ACHIEVEMENT_TYPE.MOST_RECENT_SPORTSBOOK_WIN, latestMostRecentSportsbookWin);
          }
        }
        break;
      case ACHIEVEMENT_TYPE.BIGGEST_SPORTSBOOK_WIN:
        if (achievement.value) {
          const latestBiggestSportsbookWin = (achievement.value as UserSportsbookAchievement).createdAt;
          const currentValue = localStorage.getItem(ACHIEVEMENT_TYPE.BIGGEST_SPORTSBOOK_WIN);

          if (currentValue !== latestBiggestSportsbookWin) {
            localStorage.setItem(ACHIEVEMENT_TYPE.BIGGEST_SPORTSBOOK_WIN, latestBiggestSportsbookWin);
          }
        }
        break;
      case ACHIEVEMENT_TYPE.BIGGEST_SUPERCHARGE:
        if (achievement.value) {
          const latestBiggestSupercharge = (achievement.value as UserSportsbookAchievement).createdAt;
          const currentValue = localStorage.getItem(ACHIEVEMENT_TYPE.BIGGEST_SUPERCHARGE);

          if (currentValue !== latestBiggestSupercharge) {
            localStorage.setItem(ACHIEVEMENT_TYPE.BIGGEST_SUPERCHARGE, latestBiggestSupercharge);
          }
        }
        break;
      case ACHIEVEMENT_TYPE.BEST_CASHOUT:
        if (achievement.value) {
          const latestBestCashOut = (achievement.value as UserSportsbookAchievement).createdAt;
          const currentValue = localStorage.getItem(ACHIEVEMENT_TYPE.BEST_CASHOUT);

          if (currentValue !== latestBestCashOut) {
            localStorage.setItem(ACHIEVEMENT_TYPE.BEST_CASHOUT, latestBestCashOut);
          }
        }
        break;
      default:
        break;
    }
  });
};

export const anyAchievementsUpdated = (achievements: UserAchievement[]) => {
  let anyChanges = false;

  achievements.forEach(achievement => {
    switch (achievement.type) {
      case ACHIEVEMENT_TYPE.FAVOURITE_SPORT:
        if (achievement.value) {
          const latestFavouriteSport = (achievement.value as UserFavouriteSportAchievement).lastBetPlacedAt;
          const currentValue = localStorage.getItem(ACHIEVEMENT_TYPE.FAVOURITE_SPORT);

          if (currentValue !== latestFavouriteSport) {
            anyChanges = true;
          }
        }
        break;
      case ACHIEVEMENT_TYPE.FAVOURITE_CASINO_GAME:
        if (achievement.value) {
          const latestFavouriteCasinoGame = (achievement.value as UserFavouriteCasinoGameAchievement).createdAt;
          const currentValue = localStorage.getItem(ACHIEVEMENT_TYPE.FAVOURITE_CASINO_GAME);

          if (currentValue !== latestFavouriteCasinoGame) {
            anyChanges = true;
          }
        }
        break;
      case ACHIEVEMENT_TYPE.BIGGEST_CASINO_WIN:
        if (achievement.value) {
          const latestBiggestCasinoWin = (achievement.value as UserBiggestCasinoWinAchievement).createdAt;
          const currentValue = localStorage.getItem(ACHIEVEMENT_TYPE.BIGGEST_CASINO_WIN);

          if (currentValue !== latestBiggestCasinoWin) {
            anyChanges = true;
          }
        }
        break;
      case ACHIEVEMENT_TYPE.FIRST_CASINO_WIN:
        if (achievement.value) {
          const latestFirstCasinoWin = (achievement.value as UserFirstCasinoWinAchievement).createdAt;
          const currentValue = localStorage.getItem(ACHIEVEMENT_TYPE.FIRST_CASINO_WIN);

          if (currentValue !== latestFirstCasinoWin) {
            anyChanges = true;
          }
        }
        break;
      case ACHIEVEMENT_TYPE.FIRST_SPORTSBOOK_WIN:
        if (achievement.value) {
          const latestFirstSportsbookWin = (achievement.value as UserSportsbookAchievement).createdAt;
          const currentValue = localStorage.getItem(ACHIEVEMENT_TYPE.FIRST_SPORTSBOOK_WIN);

          if (currentValue !== latestFirstSportsbookWin) {
            anyChanges = true;
          }
        }
        break;
      case ACHIEVEMENT_TYPE.MOST_RECENT_SPORTSBOOK_WIN:
        if (achievement.value) {
          const latestMostRecentSportsbookWin = (achievement.value as UserSportsbookAchievement).createdAt;
          const currentValue = localStorage.getItem(ACHIEVEMENT_TYPE.MOST_RECENT_SPORTSBOOK_WIN);

          if (currentValue !== latestMostRecentSportsbookWin) {
            anyChanges = true;
          }
        }
        break;
      case ACHIEVEMENT_TYPE.BIGGEST_SPORTSBOOK_WIN:
        if (achievement.value) {
          const latestBiggestSportsbookWin = (achievement.value as UserSportsbookAchievement).createdAt;
          const currentValue = localStorage.getItem(ACHIEVEMENT_TYPE.BIGGEST_SPORTSBOOK_WIN);

          if (currentValue !== latestBiggestSportsbookWin) {
            anyChanges = true;
          }
        }
        break;
      case ACHIEVEMENT_TYPE.BIGGEST_SUPERCHARGE:
        if (achievement.value) {
          const latestBiggestSupercharge = (achievement.value as UserSportsbookAchievement).createdAt;
          const currentValue = localStorage.getItem(ACHIEVEMENT_TYPE.BIGGEST_SUPERCHARGE);

          if (currentValue !== latestBiggestSupercharge) {
            anyChanges = true;
          }
        }
        break;
      case ACHIEVEMENT_TYPE.BEST_CASHOUT:
        if (achievement.value) {
          const latestBestCashOut = (achievement.value as UserSportsbookAchievement).createdAt;
          const currentValue = localStorage.getItem(ACHIEVEMENT_TYPE.BEST_CASHOUT);

          if (currentValue !== latestBestCashOut) {
            anyChanges = true;
          }
        }
        break;
      default:
        break;
    }
  });

  return anyChanges;
};
